import { useCallback } from 'react';
import { findConfigNodeByCode, retrieveCodes } from '../../../../../components/SearchForm/components/AirportsWidget/utils/config.js';
export const useAirportsWidgetConfig = ({
  airports
}) => {
  const retrieveRegions = useCallback(() => airports.map(({
    code
  }) => code), [airports]);
  const retrieveSubRegions = useCallback(code => {
    const node = findConfigNodeByCode(airports, code);
    if (!node || node.airports) {
      return [];
    }
    return node.children?.map(({
      code
    }) => code) || [];
  }, [airports]);
  const retrieveAllCodes = useCallback(() => {
    const regions = retrieveRegions();
    return regions.reduce((acc, region) => [...acc, ...(retrieveCodes(airports, region) || [])], []);
  }, [retrieveRegions, retrieveCodes, airports]);
  const retrieveCodesWrapper = useCallback(code => retrieveCodes(airports, code), [airports]);
  return {
    retrieveCodes: retrieveCodesWrapper,
    retrieveRegions,
    retrieveSubRegions,
    retrieveAllCodes
  };
};